import API from "../api/apiClient";

export const loginUser = async (email, password) => {
  const res = await API.post("/auth/login", {
    email: email.trim(),
    password: password.trim(),
  });
  return res.data;
};

export const registerUser = async (data) => {
  const res = await API.post("/auth/register", data);
  return res.data;
};

export const getUserProfile = async () => {
  const res = await API.get("/auth/me");
  return res.data;
};
